import { render, staticRenderFns } from "./TableColumnItemPropertyEditor.vue?vue&type=template&id=455b6bd8&scoped=true&"
import script from "./TableColumnItemPropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./TableColumnItemPropertyEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TableColumnItemPropertyEditor.vue?vue&type=style&index=0&id=455b6bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455b6bd8",
  null
  
)

export default component.exports